import React, { Component } from 'react';
import {connect} from  'react-redux';
import CallsCompleted from './allreports/callscompletedreport/callscompleted';
import SalvageCount from './allreports/salvagecountreport/salvagecount';
import DailyDeposit from './allreports/dailydepositreport/dailydeposit';
import StorageCount from './allreports/storagecountreport/storagecount';
import UnitsReleased from './allreports/unitsreleasedreport/unitsreleased';
import NoAbandonedVehicles from './allreports/noabandonedvehiclesreport/noabandonedvehicles';
import PaylessInventory from './allreports/paylessinventoryreport/paylessinventory';
import InvoicesByStorageTime from './allreports/InvoicesByStorageTime/InvoicesByStorageTime';
import TitledInvoices from './allreports/TitledInvoices/TitledInvoices';
import {dashboardViewAccess,dashboardTailViewAccess} from '../../util/accessLevelMethods';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as spinnerActions from '../../actions/spinnerAction'
const pageTitle="Reports Dashboard";
const moduleName="Reports";
const reportDashboardTailsTitles={
    CallsCompleted:'Calls Completed',
    DailyDeposit:'Revenue',
    NoAbandonedVehicles:'AVR not filed',
    PaylessInventory:'Payless Inventory',
    SalvageCount:'Salvage Sold',
    StorageCount:'Storage Inventory',
    UnitsReleased:'Vehicles Released',
    titeled:'Vehicles Titled',
    impounded:"Vehicles Impounded"
  }
class Reports extends Component {
    constructor(props){
        super(props);
        this.getTailsViewAccess=this.getTailsViewAccess.bind(this);
    }
    componentWillMount=()=>{
        document.title=pageTitle
    }
    getTailsViewAccess=()=>{
        let resultObj=new Object();
        (this.props.dashboardAccess[moduleName]||[]).map((item)=>{
            resultObj[item.tileName.toLowerCase()]=dashboardTailViewAccess(moduleName,item.tileName,this.props.dashboardAccess)
        });
        return resultObj;
    }
    render() {
        return (
            <>
            {
                dashboardViewAccess(moduleName,this.props.dashboardAccess)===true?
            <div class="row">
                <div class="col-xl-12 col-md-12 col-lg-12">                                                                                          
                    <h4><i className="fa fa-flag"></i> { pageTitle } </h4>
                    {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.CallsCompleted.toLowerCase()]===true?
                    <CallsCompleted />:null
                    }
                     {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.impounded.toLowerCase()]===true?
                    <InvoicesByStorageTime />   :null}
                     {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.UnitsReleased.toLowerCase()]===true?
                    <UnitsReleased />:null}
                    {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.DailyDeposit.toLowerCase()]===true?
                    <DailyDeposit />:null}  {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.StorageCount.toLowerCase()]===true?
                    <StorageCount />:null}
                   {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.NoAbandonedVehicles.toLowerCase()]===true?
                    <NoAbandonedVehicles />:null}  {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.titeled.toLowerCase()]===true?
                    <TitledInvoices />   :null}    
                    {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.SalvageCount.toLowerCase()]===true?
                    <SalvageCount />:null}
                     {
                        this.getTailsViewAccess()[reportDashboardTailsTitles.PaylessInventory.toLowerCase()]===true?
                    <PaylessInventory />   :null}  
                    
                           
                </div>
            </div>:
            <div className="pd-10">
            <div className="error-page-wrap text-center color-dark">
            <h1 className="color-dark weight-500">Error: 403 Forbidden</h1>
            <p>Sorry, access to this resource on the server is denied.
            </p>
            </div>
            </div>
            }
            </>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        authInfo: state.authInfo,
        dashboardAccess:state.dashboardAccess
    }
  };
export default connect(mapStateToProps) (Reports);